app.service('persistentObjectsHelper', ['persistentService', 'payerSurveyHelper',
  function (persistentService, payerSurveyHelper) {
    const persistentObjectsHelper = this;

    persistentObjectsHelper.removeObjectFromStorageArray = function (object_id, property_name) {
      const saved_objects = persistentService.getLocalStorageObject(
        property_name
      );

      if (!saved_objects) {
        return;
      }

      for (let i = 0; i < saved_objects.length; i++) {
        if (saved_objects[i].id == object_id) {
          saved_objects.splice(i, 1);

          // update storage
          persistentService.saveLocalStorageObject(
            saved_objects,
            property_name
          );

          return true;
        }
      }
    };

    persistentObjectsHelper.removeObjectFromStorageDictionary = function (object_id, property_name) {
      const saved_objects = persistentService.getLocalStorageObject(
        property_name
      );

      if (!saved_objects) {
        return;
      }

      if (object_id in saved_objects) {
        delete saved_objects[object_id];

        // update storage
        persistentService.saveLocalStorageObject(
          saved_objects,
          property_name
        );
        return true;
      }
    };

    persistentObjectsHelper.saveObjectsInLocalStorage = function (property_name, object_to_save) {
      persistentService.saveLocalStorageObject(
        object_to_save,
        property_name
      );
    };

    persistentObjectsHelper.getSavedClarifications = function (scope, backend_clarifications) {
      // here we generate combined array of saved clarifications
      // from backend and localstorage

      const saved = persistentService.getLocalStorageObject(
        scope.property_question_clarifications
      );

      if (!saved) {
        return angular.copy(backend_clarifications);
      }

      const combined_objects = angular.copy(saved);

      // iterate over backend_clarifications and add missing to storage
      for (let i = 0; i < backend_clarifications.length; i++) {
        const backend_item = backend_clarifications[i];
        const saved_item = _.findWhere(saved, { id: backend_item.id });

        if (saved_item && !saved_item.clarification && backend_item.clarification) {
          const index = _.findIndex(combined_objects, { id: backend_item.id });
          combined_objects[index] = backend_item;
        }

        if (!saved_item) {
          combined_objects.push(backend_item);
        }
      }

      // todo: do we need to update localstorage? but maybe not here
      return combined_objects;
    };

    persistentObjectsHelper.getSavedResponses = function (scope, backend_responses) {
      // here we generate combined dictionary of saved responses
      // from backend and localstorage
      // this function generates 2 dictionaries:
      // 'responses' and 'responses_new'

      payerSurveyHelper.updateAllResponsesFromServer(scope, backend_responses);

      const saved = persistentService.getLocalStorageObject(
        scope.property_responses
      );

      if (!saved) {
        // this must be in dict format!!
        // updateAllResponsesFromServer saves them into 'scope.responses
        return angular.copy(scope.responses);
        //return backend_responses;
      }

      const combined_objects = angular.copy(saved);

      // iterate over backend_responses and add missing to storage
      for (let i = 0; i < backend_responses.length; i++) {
        const backend_item = backend_responses[i];
        const saved_item = _.findWhere(combined_objects, { id: backend_item.id });

        if (!saved_item) {
          // saved_item not found
          combined_objects[backend_item.question] = backend_item;
        } else if (saved_item && !saved_item.clarification_request && backend_item.clarification_request) {
          combined_objects[backend_item.question] = backend_item;
        } else if (saved_item && !saved_item.clarification_response && backend_item.clarification_response) {
          combined_objects[backend_item.question] = backend_item;
        } else {
          // here we need to compare timestamp of backend_item and saved_item
          // use which is latest
          const backend_time = new Date(backend_item.modified_datetime);
          const saved_time = new Date(saved_item.modified_datetime);

          if (backend_time > saved_time) {
            combined_objects[backend_item.question] = backend_item;
          }
        }
      }

      // todo: update storage if combined_objects != backend_responses (for single page survey only)
      return combined_objects;
    };

    persistentObjectsHelper.injectToScopeResponses = function (scope, saved_responses) {
      // here we either add saved object to 'responses' or 'responses_new'
      // depending on if 'id' is present or not
      for (const key in saved_responses) {
        const r = saved_responses[key];
        if ('id' in r) {
          scope.responses[key] = angular.copy(r);
        } else if (scope.responses_new) {
          scope.responses_new[key] = angular.copy(r);
        }
      }
    };
  }]
);
